import React from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FiBriefcase } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { useSelector } from 'react-redux'
import {
  Label,
  MenuElement,
} from '../../../../../components/Template/Sidebar'
import SmartLink from '../../../../../components/Template/Sidebar/SmartLink'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { getUserId } from '../../../../../reducers/userAccount/selectors/userAccount'

function sendMixPanel(userId) {
  return function() {
    Mixpanel.people.increment(userId, 'Profile Menu Opened', 1)
    Mixpanel.track('Main Menu Profile Item Used', {})
  }
}

function Profile({ size = 1 }: IWithSize & WithTranslation) {
  const userId = useSelector(getUserId)

  return (
    <MenuElement size={size} alignCenter={true}>
      <SmartLink size={size} to={'/profile'} onClick={sendMixPanel(userId)}>
        <Flex alignCenter={true}>
          <b>
            <FiBriefcase size={16 * size} />
          </b>
          <Label size={size} primary={true}>
            <Trans i18nKey={'menu_profile'}>Profil</Trans>
          </Label>
        </Flex>
      </SmartLink>
    </MenuElement>
  )
}

export default Profile
